import { History } from 'history';
import { Route } from 'mk2/containers/Application/Application';
import { memoizeOne } from 'mk2/helpers/cache';
import React from 'react';

export interface RouterContextValue {
    routes: Route[];
    history: History;
}

export const createRouterContextValue = memoizeOne((routes: Route[], history: History): RouterContextValue => (
    {routes, history}
));

export const RouterContext = React.createContext<RouterContextValue>(createRouterContextValue([], null));
